import React, {useEffect, useState} from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormField from './FormField'
import { useDispatch, useSelector } from 'react-redux'
import Helper from '../../services/Helper'
import { actions } from 'src/features/state'


function ValidateUserForm() {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    return (
        <Formik
            initialValues={{
                barcode : ""
            }}
            validationSchema={
                Yup.object().shape({
                    barcode : Yup.string()
                                .required('form.required')
                })
            }
            onSubmit={(values, {setFieldError}) => {
                setLoading(true)
                Helper.validateBarcodeUser(values.barcode)
                .then(user => {
                    setLoading(false)
                    if(user) {
                        dispatch(actions.setUserBadge(user))
                        dispatch(actions.setUserBarcode(values.barcode))
                    }
                    else {
                        setFieldError("barcode", "receivement.form.barcodeUser.error")
                    }
                })
            }}
            validateOnChange={false}
            validateOnBlur={false}
        >
            {({ values, handleSubmit }) => (
                <Form>
                    <FormField
                        name="barcode"
                        fieldType="password"
                        label="Crachá"
                        styleContainer={{
                            justifyContent: 'center',
                            margin: 0
                        }}
                        onKeyPress={(event) => {
                            if(event.key === "Enter") {
                                event.preventDefault()
                                handleSubmit()
                            }
                        }}
                    />
                    {loading ? 'Carregando...' : ''}
                </Form>
            )}
        </Formik>
    )
}

export default ValidateUserForm
